<panel width="600">
  <form>
    <h1>{{ 'edit-billing-info.header' | translate }}</h1>
    @if (billingInfo && company) {
      <section>
        <custom-input [label]="'general.companyName' | translate" [placeholder]="company.name" [(value)]="billingInfo.companyName" />
        <custom-input [label]="'general.vatnumber' | translate" [placeholder]="company.vatNumber" [(value)]="billingInfo.vatNumber" [validation]="validationTypeEnum.VatNumber" />
        <custom-input [label]="'general.glnNumber' | translate" [placeholder]="company.billingGln" [(value)]="billingInfo.glnNumber" [validation]="validationTypeEnum.EAN13" />
        <custom-input [label]="'general.address' | translate" [placeholder]="company.address" [(value)]="billingInfo.streetAddress" />
        <custom-input [label]="'general.zipcode' | translate" [placeholder]="company.zipcode" [(value)]="billingInfo.zipcode" [validation]="validationTypeEnum.Zip" />
        <custom-input [label]="'general.city' | translate" [placeholder]="company.city" [(value)]="billingInfo.city" />
        <custom-select [selectList]="contactsSelect"
          [label]="'edit-billing-info.contact' | translate"
          [(value)]="billingInfo!.contactId"
          (valueChange)="selectNewContact()"
        [required]="true"></custom-select>
      </section>
    }
    <section>
      <button #saveButton confirm (click)="saveBillingInfo()" [active]="canSave()">{{ 'general.save' | translate }}</button>
    </section>
  </form>
</panel>
